var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "activity" }, [
    _c("div", { staticClass: "activity__wrapper" }, [
      _c(
        "div",
        { staticClass: "activity__title" },
        [
          _c("TitleBlock", {
            attrs: { text: "Activity", size: "small", color: "brightblue" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "activity__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "column column--1-3" }, [
            _c("div", { staticClass: "activity__left-col" }, [
              _c("div", { staticClass: "activity__global-updates" }, [
                _vm._v("All Global Updates"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "activity__counter" }, [
                _vm._v(
                  "\n              " + _vm._s(_vm.count) + "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "activity__days" }, [
                _vm._v("Last " + _vm._s(_vm.period) + " Days"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "column column--2-3" }, [
            _c("div", { staticClass: "activity__right-col" }, [
              _c("div", { staticClass: "activity__most-active" }, [
                _vm._v(
                  "\n              Your most active jurisdictions\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flags" }, [
                _c(
                  "div",
                  { staticClass: "activity__countries" },
                  _vm._l(_vm.jurisdictions.slice(0, 6), function (country) {
                    return _c(
                      "div",
                      {
                        key: country.tid,
                        staticClass: "activity__country",
                        on: {
                          click: function ($event) {
                            return _vm.onCountryClick(country.tid)
                          },
                        },
                      },
                      [
                        _c(
                          "el-badge",
                          {
                            staticClass: "activity__badge",
                            attrs: {
                              value: country.count,
                              max: 100,
                              title: country.name,
                            },
                          },
                          [
                            _c("Country", {
                              attrs: {
                                iso: country.iso ? country.iso : null,
                                link:
                                  country.field_disable === 0
                                    ? country.link + "/" + country.name
                                    : null,
                                "not-active": country.field_disable !== 0,
                                access: country.product_access,
                                size: "small",
                                icon: country.flagurl,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "activity__active-days" }, [
                _vm._v(
                  "\n              Last " +
                    _vm._s(_vm.periodJurisdictions) +
                    " days\n            "
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }